<div class="logo my-5 text-center" style="margin: auto;">
    <img src="../../../assets/WhatsApp Image 2022-08-02 at 5.41.07 AM.jpeg" alt="" routerLink="/">
    <h5 class="display-5">Privacy Policy</h5>
  </div>

<div style="max-width: 800px; padding: 0 1rem; margin: 0 auto 5rem auto;">
    <div class="main-content">
        <p style="white-space: pre-line; font-size: 18px;" *ngIf="privacyPolicy">{{ privacyPolicy }}</p>
    </div>
    <div class="text-center my-4">
        <small style="cursor: pointer; color: gray; text-decoration: underline;" routerLink="/">Go To Homepage</small>
    </div>
</div>